export default __webpack_public_path__ + "static/media/OctDom2023.854748f7.png";